import { AfterViewInit, Directive, Input, OnDestroy } from '@angular/core';
import { ClientField } from '../models/client-field.model';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Field } from '@sb-tools/typescript/models/field.model';
import { FormCommonDataService } from '../services/form-common-data.service';
import { FieldRulesValidationService } from '../services/field-rules-validation.service';

@Directive({
    selector: '[appCheckFieldRules]',
})
export class CheckFieldRulesDirective implements AfterViewInit, OnDestroy {
    @Input() field: ClientField | Field;
    @Input() fields: ClientField[] | Field[];
    @Input() isRulesSupported?: boolean = true;

    private unsubscriber = new Subject<void>();

    constructor(private formCommonDataService: FormCommonDataService) {}

    ngAfterViewInit(): void {
        if (this.isRulesSupported) {
            this.initFieldsRules();
        }
    }

    private checkRulesValues(): void {
        this.field.rules.forEach((rule) => {
            rule.dependantFormField.isShowedBecauseOfRule =
                this.isFieldDisplayed(this.field) &&
                FieldRulesValidationService.isFieldValueMatchRule(rule, this.field);
        });
    }

    private initFieldsRules(): void {
        if (this.field.rules.length) {
            this.field.rules.forEach((rule) => {
                rule.dependantFormField =
                    this.fields.find((formField) => {
                        return formField.id === rule.dependantFieldId;
                    }) || {};

                rule.ruleValues = rule.ruleValues.map((value) => {
                    return value.toLowerCase().trim();
                });
            });

            this.formCommonDataService.formInitSubject.pipe(takeUntil(this.unsubscriber)).subscribe((form) => {
                this.initFieldsValueChangesListener(form);
            });
        }
    }

    private initFieldsValueChangesListener(form): void {
        form.valueChanges
            .pipe(debounceTime(100), distinctUntilChanged(), takeUntil(this.unsubscriber))
            .subscribe(() => {
                this.checkRulesValues();
            });
    }

    private isFieldDisplayed(formField): boolean {
        return (
            (!formField.isDependant && !formField.isHidden) ||
            (formField.isDependant && formField.isShowedBecauseOfRule)
        );
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
